<template>
  <div class="grid poll">

    <app-question :data-heading="interaction.descricao"
                  :data-color="interaction.estilo.question.color"></app-question>

    <div class="options grid-center">
      <template v-for="(option, index) in interaction.opcoes">
        <button class="btn btn-round text-bold poll-action"
                :key="index"
                :class="{'mb-3': index !== interaction.opcoes.length - 1}"
                :style="buttonStyle(interaction.estilo)"
                @click="$emit('next', option.id)">
          {{option.nome}}
        </button>
      </template>
    </div>

  </div>
</template>

<script>
import AppQuestion from "./Question";
import buttonStyle from "../../../../interactions/components/interaction/mixins/button-style";
import dataInteractionProp from "../mixins/data-interaction-prop";

export default {
  components: {
    AppQuestion,
  },

  mixins: [buttonStyle, dataInteractionProp],
};
</script>

<style scoped>
</style>
